export default "__VITE_ASSET__C847OuLJ__"